<template>
  <div class="filter-container">
    <b-field horizontal :label="`${this.label}:`">

      <em>From:</em>
      <b-datepicker :value="fromValue"
        @input="(d) => handleInput(d, toValue)"
        icon="calendar-today">
        <button class="button is-primary"
          @click="handleInput(new Date(), toValue)">
          <b-icon icon="calendar-today"></b-icon>
          <span>Today</span>
        </button>

        <button class="button is-danger"
          @click="handleInput(null, toValue)">
          <b-icon icon="close"></b-icon>
          <span>Clear</span>
        </button>
      </b-datepicker>

      <em>To:</em>
      <b-datepicker :value="toValue"
        @input="(d) => handleInput(fromValue, d)"
        icon="calendar-today">
        <button class="button is-primary"
          @click="handleInput(fromValue, new Date())">
          <b-icon icon="calendar-today"></b-icon>
          <span>Today</span>
        </button>

        <button class="button is-danger"
          @click="handleInput(fromValue, null)">
          <b-icon icon="close"></b-icon>
          <span>Clear</span>
        </button>
      </b-datepicker>
    </b-field>
  </div>
</template>


<script>
import isEqual from 'lodash/isEqual';

export default {
  props: {
    queryKey: String,
    label: String,
    query: { type: Array, default: () => [] },
    fromKeyGetter: { type: Function, default: k => `${k}__gte` },
    toKeyGetter: { type: Function, default: k => `${k}__lte` },
  },
  computed: {
    fromValue() {
      const fromQuery = this.query.find(q => q.queryKey === this.fromKeyGetter(this.queryKey));
      return fromQuery && new Date(fromQuery.value);
    },
    toValue() {
      const toQuery = this.query.find(q => q.queryKey === this.toKeyGetter(this.queryKey));
      return toQuery && new Date(toQuery.value);
    },
  },
  methods: {
    handleInput(fromValue, toValue) {
      const fromFormatted = fromValue && this.$moment(fromValue).format('YYYY-MM-DD');
      const toFormatted = toValue && this.$moment(toValue).format('YYYY-MM-DD');
      const newQuery = [{
        queryKey: this.fromKeyGetter(this.queryKey),
        value: fromFormatted,
        label: `${this.label} after: ${fromFormatted}`,
      }, {
        queryKey: this.toKeyGetter(this.queryKey),
        value: toFormatted,
        label: `${this.label} before: ${toFormatted}`,
      }].filter(q => q.value);

      if (isEqual(newQuery, this.query)) {
        return;
      }
      this.$emit('input', newQuery);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
